import { Component } from '@angular/core';
import { NavbarComponent } from '../new-components/navbar/navbar.component';
import { HeroComponent } from '../new-components/hero/hero.component';
import { LogoMarqueeComponent } from '../new-components/logo-marquee/logo-marquee.component';
import { FeaturedJobsComponent } from '../new-components/featured-jobs/featured-jobs.component';
import { MockInterviewsComponent } from '../new-components/mock-interviews/mock-interviews.component';
import { AssessmentsComponent } from '../new-components/assessments/assessments.component';
import { WhyChooseComponent } from '../new-components/why-choose/why-choose.component';
import { JourneyTimelineComponent } from '../new-components/journey-timeline/journey-timeline.component';
import { TestimonialsComponent } from '../new-components/testimonials/testimonials.component';
import { StatsComponent } from '../new-components/stats/stats.component';
import { ResumeBuilderComponent } from '../new-components/resume-builder/resume-builder.component';
import { CareerRoadmapComponent } from '../new-components/career-roadmap/career-roadmap.component';
import { WhatsAppCommunityComponent } from '../new-components/whats-app-community/whats-app-community.component';
import { FinalCTAComponent } from '../new-components/final-c-t-a/final-c-t-a.component';
import { FooterComponent } from '../new-components/footer/footer.component';
import { FloatingWhatsappComponent } from '../../shared/components/floating-whatsapp/floating-whatsapp.component';
import { FeaturedMockTestComponent } from '../new-components/featured-mock-test/featured-mock-test.component';
import { FeaturedMockInterviewComponent } from '../new-components/featured-mock-interview/featured-mock-interview.component';

@Component({
	selector: 'app-new-home',
	standalone: true,
	imports: [
		NavbarComponent,
		HeroComponent,
		LogoMarqueeComponent,
		FeaturedJobsComponent,
		FeaturedMockTestComponent,
		FeaturedMockInterviewComponent,
		MockInterviewsComponent ,
		AssessmentsComponent,
		WhyChooseComponent,
		JourneyTimelineComponent,
		TestimonialsComponent,
		StatsComponent,
		ResumeBuilderComponent,
		CareerRoadmapComponent,
		WhatsAppCommunityComponent,
		FinalCTAComponent,
		FooterComponent,
		FloatingWhatsappComponent
	],
	templateUrl: './new-home.component.html',
	styleUrl: './new-home.component.scss'
})
export class NewHomeComponent {
}
